import { render } from "./TemplateNameModal.vue?vue&type=template&id=8e7d8b50&scoped=true"
import script from "./TemplateNameModal.vue?vue&type=script&lang=js"
export * from "./TemplateNameModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/TemplateNameModal.scss?vue&type=style&index=0&id=8e7d8b50&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7d8b50"]])

export default __exports__